module.exports = __webpack_public_path__ + "static/media/404-desktop.36791de7.png";